import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html'

})
export class LoginModalComponent implements OnDestroy, OnChanges {
  @Input()
  showModal = false;
  @Input()
  refreshUrl = '';

  @Output()
  close = new EventEmitter();

  @ViewChild('template') modalTemplate: TemplateRef<any>;
  public modalRef: BsModalRef = null;
  private silentRefreshPostMessageEventListener: EventListener = (e: MessageEvent) => {
    const message: string = e.data;
    if (message === 'closeMe') {
      this.close.emit();
    }
  }

  constructor(private modalService: BsModalService) {
    window.addEventListener('message', this.silentRefreshPostMessageEventListener, false);
    this.modalService.config.ignoreBackdropClick = true;
    this.modalService.config.keyboard = false;
  }

  public login(): void {
    window.open(this.refreshUrl, null, 'menubar=no,location=no,resizable=no,scrollbars=no,status=no');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.showModal) {
      this.modalRef = this.modalService.show(this.modalTemplate);
    } else if (this.modalRef !== null) {
      this.modalRef.hide();
      this.modalRef = null;
    }

  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.silentRefreshPostMessageEventListener);
  }
}





// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/login/login-modal.component.ts